module.exports = __webpack_public_path__ + "bf662793d5ee790951e14a1eb6c216a7.svg";